/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon16Solid = forwardRef('MediaUiAPlayPauseIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "m8.4 6.8-6-4.5C1.411 1.558 0 2.264 0 3.5v9c0 1.236 1.411 1.942 2.4 1.2l6-4.5c.8-.6.8-1.8 0-2.4Z" }),
        React.createElement("path", { d: "M15 2a1 1 0 0 1 1 1v10a1 1 0 1 1-2 0V3a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { d: "M12 3a1 1 0 1 0-2 0v10a1 1 0 1 0 2 0V3Z" })));
});
